/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchoolClass } from '../../models/school-class';

export interface GetSchoolClasses$Params {
  schoolId: string;
}

export function getSchoolClasses(http: HttpClient, rootUrl: string, params: GetSchoolClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SchoolClass>>> {
  const rb = new RequestBuilder(rootUrl, getSchoolClasses.PATH, 'get');
  if (params) {
    rb.path('schoolId', params.schoolId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SchoolClass>>;
    })
  );
}

getSchoolClasses.PATH = '/school/{schoolId}/classes';
